























import { defineComponent, reactive, toRefs, watch } from '@vue/composition-api';
import request from '@/utils/request';

export default defineComponent({
  name: 'AsyncSelect',
  props: {
    name: {
      type: String,
      defalut: 'name'
    },
    url: {
      type: String,
      defalut: ''
    },
    formSize: {
      type: String,
      defalut: 'small'
    },
    placeholder: {
      type: String,
      defalut: ''
    },
    disabled: {
      type: Boolean,
      defalut: false
    },
    options: {
      type: Array,
      defalut: []
    },
    initValue: {
      type: String,
      defalut: ''
    },
    asyncName: {
      type: String,
      defalut: ''
    },
    labelName: {
      type: String,
      defalut: 'name'
    },
    valueName: {
      type: String,
      defalut: 'value'
    }
  },
  setup( props: any, { emit }) {
    const state = reactive({
      loading: false,
      value:  props.initValue || '',
      option: props.options || [],
      labelNames: props.labelName || 'name',
      valueNames: props.valueName || 'value',
    });
    
    const remoteMethod = async (query) => {
      if (query !== '') {
        state.loading = true;
        // setTimeout(async () => {
        state.loading = false;
        const parms = {
          current: 1,
          size: 30
        };
        if (props.name) {
          parms[props.asyncName || props.name] = query;
        }
        const [fileName, url] = props.url.split('-');
        const result = await request(fileName, url, parms);
        state.option = result.data;
        // }, 200);
      } else {
        state.option = [];
      }
    };
    watch(()=> props.options, (newValue)=> {
      state.option = newValue;
    });
    watch(()=> props.initValue, (newValue)=> {
      state.value = newValue;
    });
    const change = (value) => {
      emit('onChange', [value, props.name]);
    };
    return  {
      ...toRefs(state),
      remoteMethod,
      change
    };
  },
});
